import React from "react";
import { FooterContent } from "@/types/footer";
import { defaultFooterContent } from "./defaultFooterContent";
import { Heading } from "@/components/Heading";
import { Paragraph } from "@/components/Paragraph";

interface PosterBoldFooterProps {
  content?: FooterContent;
}

const PosterBoldFooter: React.FC<PosterBoldFooterProps> = ({
  content = defaultFooterContent,
}) => {
  // Group columns by columnName so each header gets its links
  const grouped: Record<string, { label: string; url: string }[]> = {};
  for (const link of content.columns) {
    const key = link.columnName ?? "Links";
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push({ label: link.label, url: link.url });
  }

  return (
    <footer className="bg-secondary text-secondary-foreground">
      <div className="container mx-auto grid grid-cols-2 gap-10 px-6 py-16 md:grid-cols-4">
        {Object.entries(grouped).map(([columnName, links]) => (
          <div key={columnName}>
            <Heading
              level="h6"
              websiteStyle="posterBold"
              className="text-secondary-foreground"
            >
              {columnName}
            </Heading>
            <ul className="mt-4 space-y-2">
              {links.map(link => (
                <li key={link.label}>
                  <a
                    href={link.url}
                    className="text-sm font-semibold text-secondary-foreground hover:underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <Heading
            level="h6"
            websiteStyle="posterBold"
            className="text-secondary-foreground"
          >
            Contact
          </Heading>
          <Paragraph
            websiteStyle="posterBold"
            size="sm"
            className="mt-4 whitespace-pre-line text-secondary-foreground"
          >
            {content.contact.address}
          </Paragraph>
          {content.contact.phone && (
            <Paragraph
              websiteStyle="posterBold"
              size="sm"
              className="mt-2 text-secondary-foreground"
            >
              {content.contact.phone}
            </Paragraph>
          )}
        </div>
      </div>
      <div className="border-t border-secondary-foreground/20">
        <div className="container mx-auto flex flex-col items-start justify-between gap-4 px-6 py-6 md:flex-row md:items-center">
          <Paragraph
            websiteStyle="posterBold"
            size="sm"
            className="text-secondary-foreground"
          >
            {content.copyright}
          </Paragraph>
          <div className="flex gap-4">
            {content.socialLinks.map(s => (
              <a
                key={s.label}
                href={s.url}
                className="text-sm font-semibold text-secondary-foreground hover:underline"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PosterBoldFooter;
